<template>
  <span :class="setClass">{{ t("required") }}</span>
</template>

<script>
import I18n from "../../i18n/i18n";
import "../../i18n/ja";
import { i18n } from "../../mixins/i18n";

export default {
  mixins: [i18n],
  props: {
    setClass: {
      type: String,
      default: "badge badge-required ml-1 mr-3"
    }
  }
};

</script>

<style scoped>
</style>
